import { BaseModel, Form, Resource, Entry, EntryTypes } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../resource/lea.resource';
import { CoursModel } from '../../cours/models/cours.model';
import { TABLE } from '../../app.constantes';
import { DateHelper } from '../helpers/date.helper';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/inscription',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'historique': {},
    'table': {},
    'tableCours': {},
    'tableStateChange': {},
    'create': {},
})
export class InscriptionModel extends BaseModel {

    // const STATUT_NON_PAYE=0;
	// const STATUT_PAYE=1;

    _explicitType: string = 'Inscription';

    @Entry({
        base: {
            hidden: true,
        },
        'table': {},
        'historique': {},
        'tableCours': {},
        'tableStateChange': {},
    })
	id: string;
    idInscriptionOrigine: string;

    @Entry({
        base: {
            type: EntryTypes.DATE,
            label: 'Début',
            formatDisplay: 'DD/MM/YYYY',
            minWidth: TABLE.MIN_WIDTH.DATE,
            colOrder: 1,
        },
        'table': {
            /*transform: (value, row) => {
                return DateHelper.dateBDD2String(row);
            }*/
        },
        'historique': {},
        'tableCours': {
            transform: (value, row) => {
                return DateHelper.dateBDD2String(value);
            },
            isEditable: true,
        },
        'tableStateChange': {
            transform: (value, row) => {
                return DateHelper.dateBDD2String(value);
            },
            isEditable: false,
        },
        'edit': {
            transform: (value, row) => {
                console.log(value, row);
                return value;
            },
            css: {
                input: '',
                group: '',
            },
        }
    })
    dateDebut: string;

    @Entry({
        base: {
            type: EntryTypes.DATE,
            formatDisplay: 'DD/MM/YYYY',
            label: 'Fin',
            minWidth: TABLE.MIN_WIDTH.DATE,
            colOrder: 2,
            transform: (value, row) => {
                return DateHelper.dateBDD2String(value);
            },
        },
        'table': {},
        'historique': {},
        'tableCours': {
            transform: (value, row) => {
                return DateHelper.dateBDD2String(value);
            },
            isEditable: true,
        },
        'tableStateChange': {
            transform: (value, row) => {
                return DateHelper.dateBDD2String(value);
            },
            isEditable: true,
        },
    })
    dateFin: string;

    @Entry({
        'tableCours': {
            // type: EntryTypes.TABLE,
            colOrder: 3,
            label: 'Eleve',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
            //transform: (value) => value ? `${value.prenom} ${value.nom} (${value.id})` : null,
            hidden: true, //utilisation de eleveLibelle pour pouvoir trier
        },
        'tableStateChange': {
            hidden: true, // utilisé pour un seul élève qui apparait dans le titre
            // type: EntryTypes.TABLE,
            colOrder: 3,
            label: 'Eleve',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
            transform: (value) => value ? `${value.prenom} ${value.nom} (${value.id})` : '',
        },
    })
    eleve: any; //string; // EleveModel ou string (pour éviter dépendance cyclique);

    @Entry({
        'tableCours': {
            // type: EntryTypes.TABLE,
            colOrder: 3,
            label: 'Eleve',
            // flexGrow: 1,
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM,
        },
    })
    eleveLibelle: string; // EleveModel ou string (pour éviter dépendance cyclique);
    eleveid: number;
    cours: CoursModel;

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Etat',
            minWidth: TABLE.MIN_WIDTH.LIBELLE_ACTION,
            colOrder: 13,
            hidden: true,
        },
        'table': {
            hidden: false,
            css: {
                input: '',
                group: '',
            },
            type: EntryTypes.STATIC,
            // fetchOptions: inscriptionActionFetchOptions, mis en place avec un registerDynamicProperty car nécessite l'année scolaire en paramètre
            isEditable: true, // mettre à true avec le type et les données liste déroulante
            transform: (value, row) => (row && row.libelle_action) ? row.libelle_action : '',
        },
        'historique': {},
        'tableCours': {
            hidden: false,
            css: {
                input: '',
                group: '',
            },
            type: EntryTypes.SELECT,
            // fetchOptions: inscriptionActionFetchOptions, mis en place avec un registerDynamicProperty car nécessite l'année scolaire en paramètre
            isEditable: true, // mettre à true avec le type et les données liste déroulante
            transform: (value, row) => (row && row.libelle_action) ? row.libelle_action : '',
        },
        'tableStateChange': {
            hidden: false,
            css: {
                input: '',
                group: '',
            },
            type: EntryTypes.SELECT,
            // fetchOptions: inscriptionActionFetchOptions, mis en place avec un registerDynamicProperty car nécessite l'année scolaire en paramètre
            isEditable: true, // mettre à true avec le type et les données liste déroulante
            transform: (value, row) => (row && row.libelle_action) ? row.libelle_action : '',
        },
        'edit': {
            hidden: false,
            css: {
                input: '',
                group: '',
            },
            // isEditable: true,
            type: EntryTypes.SELECT,
            // fetchOptions: inscriptionActionFetchOptions, mis en place avec un registerDynamicProperty car nécessite l'année scolaire en paramètre
            // isEditable: true, // mettre à true avec le type et les données liste déroulante
            transform: (value, row) => (row && row.libelle_action) ? row.libelle_action : '',
        }
    })
    codeAction: number; // Relié à la table ref_inscription_action : saute année, congé sabbatique, exempté, démission, radié, se réinscrit...
    // statut: string; // code_action relié à la table ref_inscription_action
    
    @Entry({
        base: {
            hidden: true, // Uniquement présent pour récupérer la valeur de la BDD pour affichage dans statut
        },
        'table': {},
        'historique': {},
        'tableCours': {

        },
    })
    libelle_action: string; // Libellé du statut

	isHorsCursus: string;
    isFictif: string; // Cours fictif pour inscriptions fictives
    // (affichage d'un cursus uniquement : élève qui devrait normalement suivre un tel qui mais qui ne le suit pas)

	// Données sur la discipline élève uniquement destiné à l'affichage
	niveauEleve: string;
    cycleEleve: string;

    @Entry({
        base: {
            // type: EntryTypes.TABLE,
            label: 'Red.',
            minWidth: TABLE.MIN_WIDTH.ID,
            colOrder: 12,
            transform: (value) => value ? 'Oui' : 'Non',
        },
        'table': {},
        'historique': {},
        'tableCours': {},
        //'tableStateChange': {},
    })
    isRedoublant: string;

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Année',
            minWidth: TABLE.MIN_WIDTH.ANNEE_SCOLAIRE,
            colOrder: 11,
        },
        'table': {},
        'historique': {},
        'tableCours': {
            type: EntryTypes.NUMBER,
            isEditable: true,
        },
    })
	nbAnneeDansCycle: number; // Nombre d'années dans le cycle (y compris l'annee courante)
	// public $disciplineId;

    @Entry({
        base: {
            // type: EntryTypes.TABLE,
            label: 'Année',
            flexGrow: 1,
            colOrder: 0,
            hidden: true,
        },
        'table': {},
        'historique': {
            hidden: false,
            flexGrow: 2,
            transform: (value, row) => value ? value + '-' + (+value+1) : '', // 2020 => 2020-2021
        },
        'tableCours': {},
        'tableStateChange': {
            hidden: false,
            flexGrow: 2,
            transform: (value, row) => value ? value + '-' + (+value + 1) : '', // 2020 => 2020-2021
        },
    })
	anneeScolaire: string;

    // Données récupérées à partir des sous attributs
    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Discipline',
            minWidth: TABLE.MIN_WIDTH.DISCIPLINE,
            colOrder: 3,
        },
        'table': {},
        'historique': {},
        'tableStateChange': {
            type: EntryTypes.STATIC
        },
    })
    disciplineLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Professeur',
            minWidth: TABLE.MIN_WIDTH.NOM_PRENOM * 2,
            colOrder: 4,
        },
        'table': {},
        'historique': {},
    })
    professeurLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Salle',
            minWidth: TABLE.MIN_WIDTH.SALLE,
            colOrder: 5,
        },
        'table': {},
        'historique': {},
    })
    salleLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Jour',
            minWidth: TABLE.MIN_WIDTH.JOUR,
            colOrder: 6,
        },
        'table': {},
        'historique': {},
    })
	jourLibelle: string;
    jour: string; // valeur numérique pour le tri

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Heure',
            minWidth: TABLE.MIN_WIDTH.HORAIRE,
            colOrder: 7,
        },
        'table': {},
        'historique': {},
    })
    horaireLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Durée',
            minWidth: TABLE.MIN_WIDTH.DUREE,
            colOrder: 8,
        },
        'table': {},
        'historique': {},
    })
	dureeLibelle: string;
    duree: string; // Valeur numérisue pour le tri

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Cycle',
            minWidth: TABLE.MIN_WIDTH.CYCLE,
            colOrder: 9,
        },
        'table': {},
        'historique': {},
    })
    cycleLibelle: string;

    @Entry({
        base: {
            type: EntryTypes.TABLE,
            label: 'Niveau',
            minWidth: TABLE.MIN_WIDTH.NIVEAU,
            colOrder: 10,
        },
        'table': {},
        'historique': {},
    })
	niveauLibelle: string;
	typeCours: string;



    constructor(data?) {
        super();
        Object.assign(this, data);
        if (data) {
            this.codeAction = data['codeAction'] ? +data.codeAction : null;
            if (data.eleve) {
                this.eleveLibelle = (data.eleve.nom ? data.eleve.nom + ' ' : '') + (data.eleve.prenom ? data.eleve.prenom : '');
            } else {
                this.eleveLibelle = '';
            }
        }
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/inscriptions/inscription.model.ts